import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { clinicInfo } from '../mock';

export default function Footer() {
  return (
    <footer role="contentinfo" className="bg-[#0B0B0B] text-[#EFE9DF] pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-4 gap-12 pb-14">
          <div className="md:col-span-1">
            <div className="mb-5">
              <img
                src="/img/logo-wordmark.webp"
                alt="Beechwood Dental Studio"
                width="203"
                height="48"
                loading="lazy"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-[#EFE9DF]/70 leading-relaxed">
              Compassionate, modern dental care in the heart of Waterloo. Every smile matters.
            </p>
          </div>

          <div>
            <h3 className="text-[11px] tracking-[0.28em] uppercase text-[#C8A97E] mb-5">Visit</h3>
            <ul className="space-y-3 text-sm text-[#EFE9DF]/80">
              <li className="flex gap-3"><MapPin size={14} className="mt-1 flex-shrink-0" strokeWidth={1.5} />{clinicInfo.address}</li>
              <li className="flex gap-3"><Phone size={14} className="mt-1 flex-shrink-0" strokeWidth={1.5} />{clinicInfo.phone}</li>
              <li className="flex gap-3"><Mail size={14} className="mt-1 flex-shrink-0" strokeWidth={1.5} />{clinicInfo.email}</li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] tracking-[0.28em] uppercase text-[#C8A97E] mb-5">Hours</h3>
            <ul className="space-y-2 text-sm text-[#EFE9DF]/80">
              {clinicInfo.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-4">
                  <span>{h.day}</span>
                  <span className="text-[#EFE9DF]/60">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] tracking-[0.28em] uppercase text-[#C8A97E] mb-5 sr-only">Follow</h3>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/beechwooddentalstudio/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Beechwood Dental Studio on Instagram"
                className="w-9 h-9 border border-[#EFE9DF]/40 rounded-full flex items-center justify-center hover:bg-[#EFE9DF] hover:text-[#0B0B0B] transition-colors"
              >
                <Instagram size={14} strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61595463568014"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Beechwood Dental Studio on Facebook"
                className="w-9 h-9 border border-[#EFE9DF]/40 rounded-full flex items-center justify-center hover:bg-[#EFE9DF] hover:text-[#0B0B0B] transition-colors"
              >
                <Facebook size={14} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="hairline mb-6 opacity-40" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#EFE9DF]/50">
          <div>© {new Date().getFullYear()} Beechwood Dental Studio. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
